<template>
  <v-container fluid>
    <v-row class="forgot-password-form-container">
      <v-col lg="3"></v-col>
      <v-col cols="12" lg="6">
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate,errors }">
          <form>
            <v-card class="pa-3 forgot-password-form" elevation="10" style="border-top: 3px solid #e74a18">
              <v-card-title class="d-flex justify-center"><h1>{{$t('msg.forgot_password_header')}}</h1></v-card-title>
              <v-card-text>

                <v-alert v-show="showInvalidDataError" dense type="warning">
                  {{$t('error.registrationtoken_username_details_does_not_match')}}
                </v-alert>

                <v-alert v-show="showInvalidUserError" dense type="warning">
                  {{$t('error.register_username_not_found')}}
                </v-alert>

                <ValidationProvider name="username" :rules="{required : true, min:6, max:15, regex: /^[a-zA-Z0-9!#@-]+$/}"
                                    v-slot="{ errors, valid, failedRules }">
                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'username')"
                                :label="$t('msg.username')"
                                :placeholder="$t('error.username_required')"
                                :success="valid" append-icon="mdi-account"
                                class="pa-1" outlined
                                type="text" v-model="request.username"
                                @keydown="resetUsernameError"></v-text-field>
                </ValidationProvider>

<!--                <ValidationProvider :rules="{required : true, max:16, regex: /^[a-zA-Z0-9]+$/}" name="idNumber"-->
<!--                                    v-slot="{ errors, valid, failedRules }">-->
<!--                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'id_num')"-->
<!--                                :label="$t('registration.id_num')"-->
<!--                                :placeholder="$t('error.id_num_required')"-->
<!--                                :success="valid"-->
<!--                                append-icon="mdi-passport"-->
<!--                                @keyup="uppercase"-->
<!--                                class="pa-1 uppercase placeholder" outlined-->
<!--                                type="text" v-model="request.idNumber"-->
<!--                                @keydown="resetUserDetailsError"></v-text-field>-->
<!--                </ValidationProvider>-->

                <!--Registration Token-->
                <ValidationProvider name="registrationToken"
                                    :rules="{required : true, min:6, max:6, regex: /^[a-zA-Z0-9]+$/}"
                                    v-slot="{ errors, valid, failedRules }">
                  <v-text-field
                    :error-messages="errors.length > 0 && Object.keys(failedRules) == 0 ? $translatedServerSideMessages(errors, 'registrationToken') : $translatedErrorMessages(failedRules,'registrationToken')"
                    :label="$t('registration.verification_code')"
                    :placeholder="$t('error.registrationtoken_required')" :success="valid"
                    append-icon="mdi-check"
                    class="pa-1 required-class" outlined v-model="request.registrationToken"
                    v-on:keyup.enter="passes(reset)"></v-text-field>
                </ValidationProvider>

                <ValidationProvider name="password"
                                    :rules="{required : true, min:6, max:15, regex: /^[a-zA-Z0-9!#@-]+$/}"
                                    v-slot="{ errors, valid, failedRules }"
                                    vid="confirm">
                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'new_password')"
                                :label="$t('msg.new_password')"
                                :placeholder="$t('error.new_password_required')" :success="valid"
                                append-icon="mdi-lock"
                                class="pa-1" outlined
                                type="password" v-model="request.password"
                                v-on:keyup.enter="passes(reset)"></v-text-field>
                </ValidationProvider>
                <ValidationProvider name="confirmPassword" rules="required|confirmed:confirm"
                                    v-slot="{ errors, valid, failedRules }">
                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'confirm_new_password')"
                                :label="$t('msg.confirm_new_password')"
                                :placeholder="$t('error.confirm_new_password_required')"
                                :success="valid" append-icon="mdi-lock"
                                class="pa-1" outlined
                                type="password" v-model="request.confirmPassword"
                                v-on:keyup.enter="passes(reset)"></v-text-field>
                </ValidationProvider>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-row>
                  <v-col class="text-center">
                    <v-btn class="primary mr-5" @click="passes(reset)">{{ $t('msg.reset_button')}}</v-btn>
                    <v-btn class="secondary" @click="cancelReset">{{ $t('msg.cancel_reset')}}</v-btn>
                  </v-col>
                </v-row>

<!--                <v-row class="hidden-md-and-up">-->
<!--                  <v-col md="6" class="text-center">-->
<!--                    <v-btn class="secondary" @click="passes(reset)">{{ $t('msg.reset_button')}}</v-btn>-->
<!--                  </v-col>-->
<!--                  <v-col md="6" class="text-center">-->
<!--                    <v-btn class="primary" @click="cancelReset">{{ $t('msg.reset_button')}}</v-btn>-->
<!--                  </v-col>-->
<!--                </v-row>-->
              </v-card-actions>
            </v-card>
          </form>
        </ValidationObserver>
      </v-col>
      <v-col lg="3"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { userService } from '../_services'

export default {
  name: 'Login',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      request: {},
      loading: false,
      showInvalidDataError: false,
      showInvalidUserError: false,
      serverError: false
    }
  },
  methods: {
    cancelReset () {
      this.$router.push('/')
    },
    resetUsernameError () {
      this.showInvalidUserError = false
    },
    resetUserDetailsError () {
      this.showInvalidDataError = false
    },
    reset () {
      this.resetUsernameError()
      this.resetUserDetailsError()
      userService.resetPassword(this.request)
        .then((response) => {
          this.$router.push({ path: `/`, query: { reset: true } })
        }).catch(error => {
          if (undefined !== error.response && undefined !== error.response.data && undefined !== error.response.data.errorList && error.response.data.errorList.length > 0) {
            let e = {}
            error.response.data.errorList.forEach(error => {
              if (error.rule !== undefined) {
                console.log(error.field + '   ' + error.rule)
                e[error.field] = [{ rule: error.rule }]
                if (error.rule === 'username_details_does_not_match') {
                  this.showInvalidDataError = true
                } else if (error.rule === 'username_not_found') {
                  this.showInvalidUserError = true
                }
              }
            })
            this.$refs.observer.setErrors(e)
          } else {
            this.serverError = true
          }
        })
    },
    uppercase () {
      this.request.idNumber = this.request.idNumber.toUpperCase()
    }
  }
}
</script>

<style lang="css" scoped>
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }

  .logoStyle {
    width: 250px;
  }

  .eInsightsLogoStyle {
    width: 316px;
    height: 100px;
  }

  .v-application a {
    color: #000;
    text-decoration: none;
    opacity: .5;
  }

  .v-application a:hover {
    opacity: 1;
    text-decoration: underline;
  }
</style>
<style>
  .forgot-password-form .theme--light.v-label {
    color: rgba(0,0,0,.90);
  }

  .forgot-password-form-container {
    margin-bottom: 50px !important;
  }

  .uppercase input {
    text-transform: uppercase;
  }

  .placeholder input::placeholder {
    text-transform: none !important;
  }
</style>
